import React from 'react';
import './Chip.scss';

const Chip = ({text, event}) => {
  return (
    <div className="chip">
      {text}
      <span className="closebtn" onClick={event}>&times;</span>
    </div>
  );
};

export default Chip;
